import React from "react";

const PreviewSidebar = ({ filters = [], tabs = [], selectedTabId = null, theme }) => {
  // Get current tab's tab-specific filters
  const currentTab = tabs.find((t) => t.id === selectedTabId);
  const tabFilters = currentTab?.filters || [];

  // Combine global and tab-specific filters
  const allFilters = [
    ...filters.filter((f) => f.visible && !f.hide_on_tab),
    ...tabFilters.filter((f) => f.visible && !f.hide_on_tab),
  ];

  const sidebarStyle = {
    background: theme?.background || "#ffffff",
    borderRightColor: theme?.borderColor || "#e0e0e0",
  };

  const titleStyle = {
    color: theme?.textColor || "#333333",
  };

  if (allFilters.length === 0) {
    return (
      <div className="preview-sidebar" style={sidebarStyle}>
        <h4 className="sidebar-title" style={titleStyle}>Filters</h4>
        <p style={{ color: "#999", fontSize: "14px" }}>No filters added</p>
      </div>
    );
  }

  return (
    <div className="preview-sidebar" style={sidebarStyle}>
      <h4 className="sidebar-title" style={titleStyle}>Filters</h4>

      {allFilters.map((filter) => {
        // Extract options from the filter's JSON structure
        // Handle both formats: {label, value} and {Name, Value}
        const rawOptions = filter.options || [];
        const options = rawOptions.map(opt => ({
          value: opt.value || opt.Value || opt.Id || "",
          label: opt.label || opt.Name || opt.value || opt.Value || ""
        }));
        
        const isMultiple = Boolean(filter.multiple);
        const selectedValue = filter.selectedValue || (isMultiple ? [] : "");

        const labelStyle = {
          fontWeight: "600",
          marginBottom: "6px",
          display: "block",
          color: theme?.labelColor || "#555555",
        };

        const selectStyle = {
          width: "100%",
          padding: "8px",
          borderRadius: "4px",
          border: `1px solid ${theme?.inputBorderColor || "#d0d0d0"}`,
          background: theme?.inputBackground || "#f9f9f9",
          fontSize: "14px",
          color: theme?.textColor || "#333333",
        };

        const multiSelectStyle = {
          ...selectStyle,
          minHeight: "100px",
        };

        return (
          <div key={filter.id} className="sidebar-filter">
            <label style={labelStyle}>
              {filter.label || filter.variable_name || "Unnamed Filter"}
            </label>

            {isMultiple ? (
              <select
                multiple
                value={Array.isArray(selectedValue) ? selectedValue : [selectedValue]}
                // disabled
                style={multiSelectStyle}
              >
                {options.map((opt, idx) => (
                  <option key={idx} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            ) : (
              <select
                value={selectedValue}
                // disabled
                style={selectStyle}
              >
                <option value="">-- Select --</option>
                {options.map((opt, idx) => (
                  <option key={idx} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default PreviewSidebar;